import styled from 'styled-components';
import { colors, remCalc } from '@prisjakt/ui-base';

export const Columns = styled.div`
  flex: 0 0 100%;
  max-width: 100%;
  padding-right: ${remCalc(10)};
  padding-left: ${remCalc(10)};
`;

export const Row = styled.div`
  max-width: ${remCalc(1000)};
  margin-right: auto;
  margin-left: auto;
  display: flex;
  flex-flow: row wrap;
`;

export const EmailSent = styled(Row)`
  margin-bottom: 50px;
  p {
    margin: 0;
  }
  a {
    color: ${colors.lightBlue3};
    text-decoration: underline;
  }
`;

export const Title = styled.h1`
  font-size: 32px;
  font-weight: normal;
  margin-bottom: 26px;
`;

export const Link = styled.button`
  cursor: pointer;
  color: ${colors.lightBlue3};
  text-decoration: underline;
  &:hover {
    color: ${colors.green1};
  }
`;
export const Notice = styled(Columns)`
  font-size: 20px;
  margin: 20px 0 70px 0;
  vertical-align: center;
  display: flex;
  align-items: center;
  path {
    fill: #fff;
  }
`;
export const NoticeIcon = styled.img`
  width: 50px;
  height: 50px;
`;
